import type { SVGProps } from 'react';

const SvgPauseFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <rect x={6} y={3} width={4} height={18} rx={1} fill='currentColor' />
    <rect x={14} y={3} width={4} height={18} rx={1} fill='currentColor' />
  </svg>
);
export default SvgPauseFilled;
